<template>
    <div class="space-y-2">
        <form-select name="Target template" :model-value="targetValue" @update:model-value="setTarget">
            <option value="">Select template…</option>
            <option v-if="missingTarget" :value="targetValue">T{{ targetValue }} — unavailable</option>
            <option v-for="target in templateTargets" :key="target.value" :value="target.value">
                {{ target.label }}
            </option>
        </form-select>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    action: { type: Object, required: true },
    templateTargets: { type: Array, required: true },
});
const emit = defineEmits(['change']);
const targetValue = computed(() => props.action.target?.templateId === undefined
    ? '' : String(props.action.target.templateId));
const selectedTarget = computed(() => props.templateTargets
    .find(target => target.value === targetValue.value));
const missingTarget = computed(() => Boolean(targetValue.value) && !selectedTarget.value);

function setTarget(value) {
    props.action.target = value ? { templateId: Number(value) } : null;
    emit('change');
}
</script>
